<div class="grid">

  <div class="landing-text-container">
    <h1 class="landing-text">{{"subtitle" | transloco}} <b>{{username}}</b></h1>
  </div>

  <!-- INTERNAL (NOT CUSTOM) APPLICATIONS -->
  <div class="col-12 md:col-6 lg:col-3 p-3" *ngFor="let internalLink of links[0]; let i = index" [attr.data-index]="i">
    <div class="card landing-card"
         (mouseover)="background-color=hexToRGBA(1, 0, i)"
         (mouseout)="background-color=hexToRGBA(0, 0, i)"
         [style.background-color]="links[0][i].color">

      <div class="optionButtonDiv" *ngIf="internalLink.code !== 'CONTROL_PLATFORM'">
        <button class="button-rounded btn-primary-light mr-2 editButton" pButton pRipple icon="pi pi-cog"
                [routerLink]="'settings/' + internalLink.code"></button>
      </div>

      <a [href]="'http://' + internalLink.url" target="_blank">
        <div class="landing-card-image">
          <img src="{{getIcon(internalLink)}}" class="p-2" alt="Icon"/>
        </div>
        <div class="landing-card-text">
          <div class="landing-card-title">
            <p>{{internalLink.name | transloco}}</p>
          </div>
          <div class="landing-card-description">
            <p>{{internalLink.description | transloco}}</p>
          </div>
        </div>
      </a>
    </div>
  </div>

  <div class="col-12">
    <hr style="border-color: #D6D6D6; width: 65%;" class="mx-auto">
  </div>

  <!-- EXTERNAL (CUSTOM) APPLICATIONS -->
  <div class="col-12 md:col-6 lg:col-3 p-3" *ngFor="let externalLink of links[1]; let i = index" [attr.data-index]="i">
    <div class="card landing-card"
         (mouseover)="background-color=hexToRGBA(1, 1, i)"
         (mouseout)="background-color=hexToRGBA(0, 1, i)"
         [style.background-color]="links[1][i].color">

<!--      <p-speedDial [model]="items"></p-speedDial>-->

      <div class="optionButtonDiv">
        <button class="button-rounded btn-primary-light mr-2 editButton" pButton pRipple icon="pi pi-pencil"
                  [routerLink]="'/external-applications/' + externalLink.uuid + '/edit'"></button>
      </div>

      <div class="optionButtonDiv">
        <button class="button-rounded btn-primary-light mr-2 deleteButton" pButton pRipple icon="pi pi-trash"
                (click)="confirmDeleteExternalApplication($event, externalLink.uuid)"></button>
      </div>

      <a [href]="'http://' + externalLink.url" target="_blank">
        <div class="landing-card-image">
          <img src="{{getIcon(externalLink)}}" class="p-2" alt="Icon"/>
        </div>
        <div class="landing-card-text">
          <div class="landing-card-title">
            <p>{{externalLink.name}}</p>
          </div>
          <div class="landing-card-description">
            <p>{{externalLink.description}}</p>
          </div>
        </div>
      </a>
    </div>
  </div>

</div>

